import ServiceHeader from "../../ServiceComponents/ServiceHeader";
import ServiceBody from "../../ServiceComponents/ServiceBody";

import { FaGreaterThan } from "react-icons/fa6";

import ServiceSection from "../../PageElements/HomePageElements/ServiceSection";
import ConsultSection from "../../PageElements/HomePageElements/ConsultSection";

export default function CardiologyPage() {
    return (
        <>
            <ServiceHeader
                childClass="cardiologyBGSection"
                breadcrumb={<>Services <FaGreaterThan size={15} /> Cardiology</>}
                title="Cardiology"
            />

            <ServiceBody
                serviceName="Cardiology"
            />
            <ServiceSection />
            <ConsultSection />
        </>
    )
}